import format from 'date-fns/format';
import { getVesselImage, sortVoyagesByETDDate, sortVoyages } from './utils';

const portFilterList = [];

const filterPorts = port => {
  let shouldKeep = true;
  portFilterList.forEach(element => {
    if (port.name === element) {
      shouldKeep = false;
    }
  });
  return shouldKeep;
};

const filterVisits = visit => {
  let shouldKeep = true;
  portFilterList.forEach(element => {
    if (visit.Pool.Port.LocalName === element) {
      shouldKeep = false;
    }
  });
  return shouldKeep;
};

export class VoyageDataDTO {
  constructor(voyages) {
    this.voyages = [];
    this.vessels = [];
    this.ports = [];
    this.routes = [];
    this.portVisits = {};
    this.cutoffDates = [];

    if (!!voyages && voyages.length) {
      //Get all ports via visits
      let portCodes = [];
      const allVisits = voyages.map(voyage => voyage.Visits).reduce((a, b) => a.concat(b));
      allVisits.map(visit => {
        //TODO: use this to make port visit table easy?
        //TODO: VisitDTO
        const port = visit.Pool.Port;

        const portCode = port.PortCode;
        if (portCodes.indexOf(portCode) === -1) {
          this.portVisits[portCode] = [];
          portCodes.push(portCode);
          this.ports.push(new PortDTO(port));
        }
        this.portVisits[portCode].push(new VisitDTO(visit));
      });

      let vessels = [];
      let routes = [];
      for (let i = 0; i < voyages.length; i++) {
        const voyage = voyages[i];
        const vessel = voyage.Vessel;
        const route = voyage.ServiceArea.Description;

        this.voyages.push(new VoyageDTO(voyage));

        if (vessels.indexOf(vessel.Reference) === -1) {
          vessels.push(vessel.Reference);
          this.vessels.push(new VesselDTO(vessel));
        }

        if (routes.indexOf(route) === -1) {
          routes.push(route);
          this.routes.push(route);
        }
      }
    }
  }

  getPorts() {
    const filteredPortList = this.ports.filter(filterPorts);
    return filteredPortList;
  }

  getPortsByVesselReference(reference) {
    let portCodes = [];
    return this.getVoyagesByVesselReference(reference)
      .map(voyage => voyage.getPorts())
      .reduce((a, b) => a.concat(b))
      .filter(port => {
        if (portCodes.indexOf(port.portCode) === -1) {
          portCodes.push(port.portCode);
          return true;
        } else {
          return false;
        }
      });
  }

  getVesselsByRoute(route) {
    const vessels = this.getVoyagesByRoute(route).map(voyage => voyage.getVessel());

    return vessels.filter(
      (thing, index, self) => index === self.findIndex(t => t.reference === thing.reference)
    );
  }

  getRoutes() {
    return this.routes;
  }

  getVessels() {
    return this.vessels;
  }

  getVesselByReference(reference) {
    return this.vessels.filter(vessel => vessel.reference === reference.toUpperCase())[0];
  }

  getVoyages() {
    return this.voyages.sort(sortVoyages);
  }

  getVoyageByReference(reference) {
    return this.voyages.filter(voyage => voyage.reference === reference.toUpperCase());
  }

  getVoyagesByPortCode(code) {
    return this.voyages.filter(voyage => voyage.isPortInVoyage(code)).sort(sortVoyagesByETDDate);
  }

  getVoyagesByPortCodeGrouped(code) {
    const voyages = this.getVoyagesByPortCode(code);
    let grouped = {};

    for (let i = 0; i < voyages.length; i++) {
      const voyage = voyages[i];
      const vessel = voyage.getVessel();
      const vesselRef = vessel.reference;
      if (!grouped[vesselRef]) {
        grouped[vesselRef] = [];
      }

      grouped[vesselRef].push(voyage);
    }

    return Object.keys(grouped).map(key => grouped[key].sort(sortVoyagesByETDDate));
  }

  getVisitsToPort(code) {
    const visits = this.portVisits[code];
    let vessels = {};
    let months = [];

    for (let i = 0; i < visits.length; i++) {
      const visit = visits[i];
      const date = new Date(visit.ETADate);
      const month = date.getMonth();
      const vesselRef = visit.vesselReference;

      if (!vessels[vesselRef]) {
        vessels[vesselRef] = [];
      }

      vessels[vesselRef].push(visit);
      months[month] = `m${month}`;
    }

    Object.keys(vessels).map(key => {
      //TODO: map data to renderable array
    });

    return this.portVisits[code];
  }

  getVoyagesByPortAndVessel(portCode) {
    const voyages = this.getVoyagesByPortCode(portCode);
    let visits = {};
    for (let i = 0; i < voyages.length; i++) {
      const voyage = voyages[i];
      const key = voyage.getVessel().reference;
      const portVisits = voyage.getVisits().filter(visit => visit.Pool.Port.PortCode === portCode);
      if (!visits[key]) {
        visits[key] = [];
        visits[key].push(portVisits);
      } else {
        visits[key].push(portVisits);
      }
    }
    return visits;
  }

  getVoyagesByVesselReference(reference) {
    return this.voyages
      .filter(voyage => voyage.getVessel().reference === reference.toUpperCase())
      .sort(sortVoyagesByETDDate);
  }

  getVoyagesByRoute(route) {
    return this.voyages
      .filter(voyage => voyage.getLineDescription().toUpperCase() === route.toUpperCase())
      .sort(sortVoyagesByETDDate);
  }

  getPortsByRoute(route) {
    let portCodes = [];
    return this.getVesselsByRoute(route)
      .map(vessel => this.getPortsByVesselReference(vessel.reference))
      .reduce((a, b) => a.concat(b))
      .filter(port => {
        if (portCodes.indexOf(port.portCode) === -1) {
          portCodes.push(port.portCode);
          return true;
        } else {
          return false;
        }
      });
  }
}

export class PortDTO {
  constructor(props) {
    this.name = props.LocalName;
    this.fullName = props.LocalName;
    this.pointCode = props.PointCode;
    this.portCode = props.PortCode;
    this.portType = props.PortType;
    this.timeZone = props.TimeZone;
    this.timeZoneDiff = props.TimeZoneDiff;
    this.portActivity = 'D';
  }

  getName() {
    return this.name;
  }
}

export class VoyageDTO {
  constructor(props) {
    this.status = props.Status;
    this.vessel = new VesselDTO(props.Vessel);
    this.visits = props.Visits.filter(filterVisits);
    this.reference = props.Reference;
    this.lastChanged = props.LastChanged;
    this.description = props.ServiceArea.Description;
    this.ports = this.visits
      .map(visit => {
        return new PortDTO(visit.Pool.Port);
      })
      .filter(filterPorts);
  }

  getVessel() {
    return this.vessel;
  }

  getPortRegistry() {
    return this.vessel.portRegistry;
  }

  getReference() {
    return this.reference;
  }

  getPorts() {
    return this.ports.filter(filterPorts);
  }

  getPortName(portCode) {
    for (let i = 0; i < this.ports.length; i++) {
      if (this.ports[i].portCode === portCode) {
        return this.ports[i].name;
      }
    }
    return null;
  }

  isPortInVoyage(portCode) {
    return this.ports.filter(port => port.portCode === portCode).length;
  }

  getVisits() {
    return this.visits;
  }

  getLineDescription() {
    return this.description;
  }

  getLastChanged() {
    if (!this.lastChanged) {
      return '';
    }

    return format(this.lastChanged, 'DD.MM. HH:mm');
  }

  formatCutoffDate(dateString) {
    return format(dateString, 'ddd HH:mm');
  }

  getCutoffDates() {
    return this.visits.map(visit => ({
      cutoffDate: this.formatCutoffDate(visit.CutoffDate),
      name: visit.Pool.Name,
      localName: visit.Pool.Port.LocalName
    }));
  }

  getVoyageVisitsTransposed() {
    const visits = this.visits;
    let result = [];

    for (let i = 0; i < visits.length; i++) {
      const visit = visits[i];
      let visitNo = parseFloat(visit.VisitNumber.replace(',','.'));
      visitNo = !visitNo ? '' : visitNo < 10 ? `0${visitNo}` : `${visitNo}`;

      // const ETADate = new Date(visit.ETADate);
      const ETDDate = new Date(visit.ETDDate);

      result.push({
        // eta: format(ETADate, 'DD.MM.'),
        etd: format(ETDDate, 'DD.MM.'),
        port: visit.Pool.Port.LocalName,
        visitNo: visitNo,
        visitNumber: `visitnumber${visitNo}`,
        voyage: this.reference,
        //current: visit.current,
        //visited: visit.visited,
      });
    }

    return result;
  }
}

export class VesselDTO {
  constructor(props) {
    this.reference = props.Reference;
    this.name = props.Name;
    this.managerCode = props.ManagerCode;
    this.CarrierCode = props.CarrierCode;
    this.portRegistry = props.PortRegistry;
    this.port = props.Port;
    this.callSign = props.CallSign;
    this.lloydsCode = props.LLoydsCode;
    this.MMSI = props.MMSI;
    this.imgsrc = getVesselImage(props.Reference);
  }
}

export class VisitDTO {
  constructor(visit) {
    this.voyageReference = visit.VoyageReference;
    this.visitNumber = visit.VisitNumber;
    this.poolCode = visit.PoolCode;
    this.ETADate = visit.ETADate;
    this.ATADate = visit.ATADate;
    this.ETDDate = visit.ETDDate;
    this.ATDDate = visit.ATDDate;
    this.cutoffDate = visit.CutoffDate;
    this.pool = visit.Pool;
    this.portCode = visit.Pool.Port.PortCode;
    this.vesselReference = visit.VoyageReference.replace(/\d+/g, '');
  }
}

export class CutoffDateDTO {
  constructor(visit) {
    this.cutoffDate = visit.cutoffDate;
    this.LocalName = visit.LocalName;
    this.Name = visit.Name;
  }
}



// WEBPACK FOOTER //
// ./src/voyageDTO.js